import {
  DRAWER_TITLE_ID,
  DrawerTitle,
  Subhead,
  useRebrand,
} from "@growtherapy/sprout-ui";

export function Header() {
  const isRebrand = useRebrand();

  if (isRebrand) {
    return (
      <Subhead.Default as="h2" id={DRAWER_TITLE_ID}>
        How are you feeling today?
      </Subhead.Default>
    );
  }

  return <DrawerTitle>How are you feeling today?</DrawerTitle>;
}
